export default class BancoHoraArmazenamento {
    constructor() {
        this.id = null;        
        this.faltas = false;       
        this.atrasos = false;       
        this.saidasAntecipadas = false;              
        this.excessoIntevaloRefeicoes = false;
        this.faltaDeMarcacao = false; 
        this.horaExtraSegunda = false;
        this.horaExtraTerca = false;
        this.horaExtraQuarta = false;
        this.horaExtraQuinta = false;
        this.horaExtraSexta = false;
        this.horaExtraSabados = false;
        this.horaExtraDomingos = false;
        this.horaExtraFeriados = false;
        this.horaExtraFolgas = false;
        this.limiteHESegunda = null;
        this.limiteHETerca = null;
        this.limiteHEQuarta = null;
        this.limiteHEQuinta = null;
        this.limiteHESexta = null;
        this.limiteHESabados = null;    
        this.limiteHEDomingos = null;
        this.limiteHEFeriados = null;
        this.limiteHEFolgas = null;
    }    
}